import { render, staticRenderFns } from "./EventBannerForm.vue?vue&type=template&id=5bd02700&"
import script from "./EventBannerForm.vue?vue&type=script&lang=js&"
export * from "./EventBannerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports